<template>
  <section>
    <div v-if="loading" class="guests-loading">Caricamento…</div>

    <form v-else class="guest-form" @submit.prevent="onSubmit">
      <div class="form-section">
        <h3 class="form-section__title">Anagrafica societaria</h3>
        <div class="form-grid">
          <div class="form-field form-field--full">
            <label>Ragione sociale <span class="required">*</span></label>
            <input v-model.trim="form.companyName" type="text" />
          </div>
          <div class="form-field form-field--full">
            <label
              >Sede legale (indirizzo) <span class="required">*</span></label
            >
            <input v-model.trim="form.legalAddress" type="text" />
          </div>
          <div class="form-field">
            <label>CAP</label>
            <input v-model.trim="form.legalZip" type="text" />
          </div>
          <div class="form-field">
            <label>Comune <span class="required">*</span></label>
            <input v-model.trim="form.legalCity" type="text" />
          </div>
          <div class="form-field">
            <label>Provincia <span class="required">*</span></label>
            <input
              v-model.trim="form.legalProvince"
              type="text"
              maxlength="4"
            />
          </div>
          <div class="form-field">
            <label>Partita IVA <span class="required">*</span></label>
            <input v-model.trim="form.vatNumber" type="text" />
          </div>
          <div class="form-field">
            <label>Codice fiscale <span class="required">*</span></label>
            <input v-model.trim="form.taxCode" type="text" />
          </div>
          <div class="form-field">
            <label>REA / CCIAA</label>
            <input v-model.trim="form.reaNumber" type="text" />
          </div>
          <div class="form-field">
            <label>Codice univoco (SDI)</label>
            <input v-model.trim="form.sdiCode" type="text" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Contatti</h3>
        <div class="form-grid">
          <div class="form-field">
            <label>Email</label>
            <input v-model.trim="form.email" type="email" />
          </div>
          <div class="form-field">
            <label>PEC</label>
            <input v-model.trim="form.pec" type="email" />
          </div>
        </div>
        <p class="tpl-info" style="margin-top: 10px">
          <i class="fa-solid fa-circle-info"></i> Indicare almeno una tra Email
          e PEC.
        </p>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Banca e pagamenti</h3>
        <p class="tpl-info" style="margin: 0 0 12px">
          <i class="fa-solid fa-circle-info"></i> Questi dati sono il
          riferimento base; i conti usati nei documenti si gestiscono nella
          scheda <strong>Conti bancari</strong>.
        </p>
        <div class="form-grid">
          <div class="form-field">
            <label>Banca <span class="required">*</span></label>
            <input v-model.trim="form.bankName" type="text" />
          </div>
          <div class="form-field">
            <label>IBAN <span class="required">*</span></label>
            <input v-model.trim="form.iban" type="text" />
          </div>
          <div class="form-field form-field--full">
            <label>Intestazione assegni <span class="required">*</span></label>
            <input v-model.trim="form.checkPayee" type="text" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section__title">Diciture documento</h3>
        <div class="form-grid">
          <div class="form-field form-field--full">
            <label
              >Dicitura esenzione IVA <span class="required">*</span></label
            >
            <textarea v-model.trim="form.vatExemptionText" rows="2"></textarea>
          </div>
          <div class="form-field form-field--full">
            <label>Dicitura imposta di bollo (opzionale)</label>
            <textarea v-model.trim="form.stampDutyText" rows="2"></textarea>
          </div>
          <div class="form-field form-field--full">
            <label>Note a piè di documento (opzionale)</label>
            <textarea v-model.trim="form.footerNotes" rows="2"></textarea>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button
          type="submit"
          class="villa-btn villa-btn--primary"
          :disabled="saving"
        >
          <i v-if="saving" class="fa-solid fa-spinner fa-spin"></i>
          {{ saving ? "Salvataggio…" : "Salva dati società" }}
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions } from "vuex";

const FIELDS = [
  "companyName",
  "legalAddress",
  "legalZip",
  "legalCity",
  "legalProvince",
  "vatNumber",
  "taxCode",
  "reaNumber",
  "sdiCode",
  "email",
  "pec",
  "bankName",
  "iban",
  "checkPayee",
  "vatExemptionText",
  "stampDutyText",
  "footerNotes",
];

const REQUIRED = [
  ["companyName", "Ragione sociale"],
  ["legalAddress", "Sede legale"],
  ["legalCity", "Comune"],
  ["legalProvince", "Provincia"],
  ["vatNumber", "Partita IVA"],
  ["taxCode", "Codice fiscale"],
  ["bankName", "Banca"],
  ["iban", "IBAN"],
  ["checkPayee", "Intestazione assegni"],
  ["vatExemptionText", "Dicitura esenzione IVA"],
];

const emptyForm = () =>
  FIELDS.reduce((acc, k) => {
    acc[k] = "";
    return acc;
  }, {});

export default {
  name: "CompanySettingsPanel",
  data() {
    return { form: emptyForm(), loading: true, saving: false };
  },
  methods: {
    ...mapActions(["fetchCompanySettings", "updateCompanySettings"]),
    missingRequired() {
      const missing = [];
      for (const [field, label] of REQUIRED) {
        if (!String(this.form[field] ?? "").trim()) missing.push(label);
      }
      if (
        !String(this.form.email ?? "").trim() &&
        !String(this.form.pec ?? "").trim()
      ) {
        missing.push("Email o PEC");
      }
      return missing;
    },
    async load() {
      this.loading = true;
      try {
        const s = await this.fetchCompanySettings();
        const base = emptyForm();
        for (const k of FIELDS) base[k] = s?.[k] ?? "";
        this.form = base;
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Impossibile caricare i dati società."
        );
      } finally {
        this.loading = false;
      }
    },
    async onSubmit() {
      const missing = this.missingRequired();
      if (missing.length) {
        return this.$toast.error(
          `Compila i campi obbligatori: ${missing.join(", ")}.`
        );
      }
      this.saving = true;
      try {
        const s = await this.updateCompanySettings({ ...this.form });
        const base = emptyForm();
        for (const k of FIELDS) base[k] = s?.[k] ?? "";
        this.form = base;
        this.$toast.success("Dati società salvati.");
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Salvataggio non riuscito."
        );
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style src="@/css/GuestsPage.css" />
